import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import WebhooksRouter from './Webhooks/WebhooksRouter';
import ApiKeysRouter from './ApiKeys/ApiKeysRouter';
import CobrandUnitsRouter from './CobrandUnits/CobrandUnitsRouter';

const ClientSettingsPage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/webhooks`}>
                <WebhooksRouter />
            </Route>
            <Route path={`${path}/cobrand-units`}>
                <CobrandUnitsRouter />
            </Route>
            <Route path={`${path}/api-keys`}>
                <ApiKeysRouter />
            </Route>
        </div>
    );
};

export default ClientSettingsPage;
